import { DateTime } from "luxon";

export function toDateTime(date: { month: number; day: number }) {
  return DateTime.fromObject({
    month: date.month,
    day: date.day,
    year: 2023,
  });
}

export function nextDate(date: { month: number; day: number }) {
  const next = toDateTime(date).plus({ days: 1 });
  return {
    month: next.month,
    day: next.day,
  };
}

export function previousDate(date: { month: number; day: number }) {
  const previous = toDateTime(date).minus({ days: 1 });
  return {
    month: previous.month,
    day: previous.day,
  };
}

/**  Convert the Luxon date into a string in the format: M-d (no leading zeros)
 */
export function formatMonthAndDay(date: DateTime) {
  return date.toFormat("M-d");
}

export function trace<T>(value: T): T {
  console.log(value);
  return value;
}
